import React, { useState } from 'react';
import { Box, Card, Typography, Breadcrumbs, Divider, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import { useResponseHandler } from '../../../../../hooks/useResponseHandler';
import formInitialValues from './formik/formInitialValues';
import validationSchema from './formik/validationSchema';
import servicesIaFormModel from './formik/servicesIaFormModel';
import { ServicesIaForm } from './components/forms/ServicesIaForm';
// import { saveServiceIaStore } from '../../../../store/services-ia';
import { MessagesDrawerRight } from '../../../../../components/MessagesDrawerRight';
import { saveServiceIaStore } from 'store/services-ia';

export const CreateServiciosIa = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { handleResponse, ResponseComponents } = useResponseHandler();
  const { formId, formField } = servicesIaFormModel;
  const [data, setMsgErrors] = useState([]);

  const handleSubmit = async (values: any, actions: any) => {
    actions.setSubmitting(true);

    const mappedValues = {
      ...values,
      provider: values.provider?.value || values.provider,
      serviceType: values.serviceType?.value || values.serviceType,
      currency: values.currency?.value || values.currency,
    };

    const response = await dispatch(saveServiceIaStore(mappedValues));

    await handleResponse(response, 'Servicio IA Creado Con Éxito', true);
    actions.setSubmitting(false);

    if (response.ok) {
      actions.resetForm();
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <MessagesDrawerRight data={data} title={''} />
      {ResponseComponents}

      <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>
        Crear Servicio IA
      </Typography>
      <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>
          Manager
        </Typography>
        <Link color="inherit" to="/manager/plataforma-ia/configuracion/servicios">
          Listar Servicios
        </Link>
        <Typography color="textPrimary">Crear Servicio IA</Typography>
      </Breadcrumbs>

      <Divider sx={{ marginBottom: 3 }} />

      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema[0]}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Card
            sx={{
              mt: 2,
              p: 3,
              borderRadius: 2,
              boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
            }}
          >
            <Form id={formId} autoComplete="off">
              <ServicesIaForm formField={formField} />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                <Button
                  component={Link}
                  to="/manager/plataforma-ia/configuracion/servicios"
                  color="inherit"
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  Crear Servicio
                </Button>
              </Box>
            </Form>
          </Card>
        )}
      </Formik>
    </Box>
  );
};
